import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import FileUploader from './fileUploader.js';
import { changeWaitingAreaInfoForCallers, downloadPILFile } from '../../../../actions/waitingArea.js';
import { generateTrucatedFileName } from 'businessLogic/fileName.js';

export default function CenterPanel(props) {
  const dispatch = useDispatch();
  const [moreAssistanceMessageCharsLeft, setMoreAssistanceMessageCharsLeft] = useState(
    200 - props.informationForCallersForm.moreAssistance.substr(0, 200).length
  );
  const [maxChars, setMaxChars] = useState(200);
  const [moreAssistance, setMoreAssistance] = useState(props.informationForCallersForm.moreAssistance);

  const changeMoreAssistanceInfo = (value) => {
    value = value.substr(0, 200);

    setMoreAssistanceMessageCharsLeft(maxChars - value.length);
    setMoreAssistance(value);

    let informationForCallerForm = {
      ...props.informationForCallersForm,
      moreAssistance: value,
    };
    dispatch(changeWaitingAreaInfoForCallers(informationForCallerForm));
  };

  const download = () => {
    downloadPILFile(props.waitingArea.id);
  };

  return (
    <div className="ui form mrbxxxl">
      {props.updateOrView == 'update' ? (
        <div className="mrtm">
          <div className="bold title-sms mrtm mrbs">
            {APP.LANGUAGE.InformationForCallersModal.SupportInfoForCallers}
          </div>
          <Txt
            tabIndex="1"
            name="InfoForCallersMoreInfo"
            customOnChange={true}
            textareaLabelRelativeRenderOnTop
            noTitle
            style={{ minHeight: '200px' }}
            notRenderPlaceholderAsTitle={true}
            titlePlaceholder=""
            value={moreAssistance}
            onChange={changeMoreAssistanceInfo}
          />
          <div className="wa-charsRight small-font-size">
            <span>{APP.LANGUAGE.OrgUnitSupportContact.CharactersRemaining + moreAssistanceMessageCharsLeft}</span>
          </div>
          <div className="clear-both" />
        </div>
      ) : (
        <div className="mrtm">
          <div className="bold title-sms mrtm">{APP.LANGUAGE.InformationForCallersModal.SupportInfoForCallers}</div>
          <div className="sixteen wide column mrtm mrbm div-as-textArea-wrapper">
            <textarea
              className="div-as-textArea read-only"
              style={{ maxHeight: '136px' }}
              readOnly
              defaultValue={props.informationForCallersForm.moreAssistance || 'Not provided'}
            />
          </div>
        </div>
      )}
      {props.updateOrView == 'update' ? (
        <div className="mrtm">
          <div className="bold title-sms mrtm mrbs">
            {APP.LANGUAGE.InformationForCallersModal.PatientInformationLeaflet}
          </div>
          <div className="mrbm">
            <div>
              <div className="title-sms">{APP.LANGUAGE.InformationForCallersModal.PatientInformationCaption0}</div>
              <a target="mgt-console-help" href={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpCustomPIL}>
                {APP.LANGUAGE.InformationForCallersModal.PatientInformationCaption1}
              </a>
              <div className="title-sms mrbm">{APP.LANGUAGE.InformationForCallersModal.PatientInformationCaption2}</div>
            </div>
            <FileUploader
              // ref={(pilFileUploadCtrl) => {
              //   props.pilFileUploaderRef(pilFileUploadCtrl);
              // }}
              setSaveInfoDispatchObj={props.setSaveInfoDispatchObj}
              downloadFunction={download}
              defaultFileName={`${props.waitingArea.name}_Leaflet.pdf`}
              currentFileName={props.informationForCallersForm.fileName}
              isDefaultFile={props.informationForCallersForm.isDefaultFile}
            />
          </div>
        </div>
      ) : (
        <div className="mrtxl">
          <div className="bold title-sms mrtm">{APP.LANGUAGE.InformationForCallersModal.PatientInformationLeaflet}</div>
          <button
            type="button"
            className="ui labeled icon button mrtm mrbm mrrnull"
            id="download-pil"
            onClick={() => {
              download();
            }}
            style={{ fontSize: '0.9rem' }}
          >
            <i className="download icon" />
            {generateTrucatedFileName(props.informationForCallersForm.fileName)}
          </button>
        </div>
      )}
    </div>
  );
}
